/* eslint-disable react/require-default-props */
import { Layout, Spin } from 'antd';
import { Outlet } from 'react-router-dom';
import AppMenu from '../components/menu';
import { useMenu } from '../hooks/api/useMenu';
import { useUser } from '../hooks/useUser';

interface IPageContainerProps {
    menuInitIgnore?: boolean;
}

const { Content, Header } = Layout;

const PageContainer = ({ menuInitIgnore }: IPageContainerProps) => {
    const menu = useMenu();
    const user = useUser();

    return (
        <Layout>
            <Spin spinning={user.loading || menu.loading}>
                <Header>
                    <AppMenu initIgnore={menuInitIgnore} />
                </Header>
            </Spin>
            <Content>
                <Outlet />
            </Content>
        </Layout>
    );
};

export default PageContainer;
